import type { Color } from "@asap/design/styles/colors";
import { taskAction, type TaskAction } from "@asap/shared/schemas/task/action-type";

export type TaskActionDetail = {
  icon: string;
  color: Color;
};

export const TASK_ACTION_CATALOG: Record<TaskAction, TaskActionDetail> = {
  call: {
    icon: "i-ph-phone-fill",
    color: "green",
  },
  follow_up: {
    icon: "i-ph-phone-fill",
    color: "green",
  },
  phone_follow_up: {
    icon: "i-ph-phone-fill",
    color: "green",
  },
  sms_follow_up: {
    icon: "i-ph-paper-plane-tilt-fill",
    color: "blue",
  },
  send_cv: {
    icon: "i-ph-file-text-fill",
    color: "cyan",
  },
  send_sms: {
    icon: "i-ph-paper-plane-tilt-fill",
    color: "blue",
  },
  send_email: {
    icon: "i-ph-paper-plane-tilt-fill",
    color: "blue",
  },
  reference_check: {
    icon: "i-ph-chat-circle-dots-fill",
    color: "orange",
  },
  qualify: {
    icon: "i-ph-seal-check-fill",
    color: "green",
  },
  request_documents: {
    icon: "i-ph-folder-plus-fill",
    color: "yellow",
  },
  visit: {
    icon: "i-ph-map-pin-fill",
    color: "purple",
  },
  proposal_follow_up: {
    icon: "i-ph-user-focus-fill",
    color: "orange",
  },
  available: {
    icon: "i-ph-check-circle-fill",
    color: "green",
  },
};

export const getTaskActionLabels = (t: (key: string) => string): Record<TaskAction, string> => ({
  call: t("tasks.actions.call"),
  follow_up: t("tasks.actions.follow_up"),
  phone_follow_up: t("tasks.actions.phone_follow_up"),
  sms_follow_up: t("tasks.actions.sms_follow_up"),
  send_cv: t("tasks.actions.send_cv"),
  send_sms: t("tasks.actions.send_sms"),
  send_email: t("tasks.actions.send_email"),
  reference_check: t("tasks.actions.reference_check"),
  qualify: t("tasks.actions.qualify"),
  request_documents: t("tasks.actions.request_documents"),
  visit: t("tasks.actions.visit"),
  proposal_follow_up: t("tasks.actions.proposal_follow_up"),
  available: t("tasks.actions.available"),
});

export const TASK_ACTIONS: TaskAction[] = [...taskAction.options];
